import { createFilterOptions } from "@mui/material/Autocomplete";

import {
  DriverSelectOption,
  NO_DRIVER_OPTION_ID,
} from "./buildDriverSelectOptions";

const muiFilter = createFilterOptions<DriverSelectOption>();

type FilterParams = Parameters<typeof muiFilter>[1];

export function filterDriverOptions(
  options: DriverSelectOption[],
  params: FilterParams,
): DriverSelectOption[] {
  const noDriver = options.find((o) => o.id === NO_DRIVER_OPTION_ID);
  const withoutNoDriver = options.filter((o) => o.id !== NO_DRIVER_OPTION_ID);
  const filteredRest = muiFilter(withoutNoDriver, params);
  if (!noDriver) {
    return filteredRest;
  }
  const query = params.inputValue.trim().toLowerCase();
  const noDriverMatches =
    !query || noDriver.label.toLowerCase().includes(query);
  return noDriverMatches ? [noDriver, ...filteredRest] : filteredRest;
}
